
import React from "react";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface PostEditorHeaderProps {
  id?: string;
  backLink: string;
}

const PostEditorHeader: React.FC<PostEditorHeaderProps> = ({ id, backLink }) => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-between mb-6">
      <h1 className="text-2xl md:text-3xl font-bold text-elfGreen-dark">
        {id ? 'Edit Post' : 'Create New Post'}
      </h1>
      <Button 
        variant="outline" 
        onClick={() => navigate(backLink)}
        className="flex items-center"
      >
        <ArrowLeft className="mr-2 h-4 w-4" /> Back to Blog Management
      </Button>
    </div>
  );
};

export default PostEditorHeader;
